import { render, staticRenderFns } from "./JerseyButtonYellowMedium.vue?vue&type=template&id=03a1601c&scoped=true&"
import script from "./JerseyButtonYellowMedium.vue?vue&type=script&lang=ts&"
export * from "./JerseyButtonYellowMedium.vue?vue&type=script&lang=ts&"
import style0 from "./JerseyButtonYellowMedium.vue?vue&type=style&index=0&id=03a1601c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a1601c",
  null
  
)

export default component.exports